<template>
    <div class="col-sm-12">
        <table-views title="Employers" :available_columns="staticData.available_columns" :temp_filters="filters" table="employers"
                     @viewChanged="(columns, filters, sort_by, sort_direction) => setView(columns, filters, sort_by, sort_direction)"
        >
            <template v-slot:search-input>
                <input type="search" class="form-control" placeholder="search" style="display: inline-block; width: 150px;" v-model="search_query" v-on:keyup.enter="search"></input>
                <span style=" border: 1px solid #ccc; background: #fafafa; border-radius: 3px; margin: 0 5px; display: inline-block; padding: 6px 10px;">
                  {{ staticData.pacing.month }}: {{ percent(staticData.pacing.should_pace_at, 0) }}
                 </span>
            </template>
            <template v-slot:buttons>
                <table-csv-download :columns="columns" :sort_by="sort_by" :sort_direction="sort_direction" :filters="filters" :search_query="search_query"></table-csv-download>
                |
                <a class="btn btn-danger" :href="url(`admin/employer-new`)">
                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                    New Employer
                </a>
            </template>
        </table-views>

        <table-filters :filters="filters" :dropdowns="staticData.dropdowns" @filter="(filters, callback) => filter(filters, callback)"></table-filters>

        <div class="form-group" v-if="selected.length">
            <div class="form-group">
                <label style="display: block">With Selected ({{ selected.length }})</label>
                <table-employer-tags :colors="staticData.dropdowns.colors" :selected="selected" @updated="refresh"></table-employer-tags>
                |
                <table-single-account-cbr :selected_employers="selected"/>
                <table-multi-account-cbr :selected_employers="selected"/>
            </div>
        </div>

        <table-table
            :sort_by="sort_by"
            :sort_direction="sort_direction"
            :rows="rows"
            :sum="sum"
            :columns="columnDefinition"
            :dropdowns="staticData.dropdowns"
            @sorted="(d) => sort(d.sort_by, d.sort_direction)"
            @select="(ids) => select(ids)"
            @openEmployerNotes="(employerId) => openEmployerNotes(employerId)"
            v-loading="loading"
            ref="dataTable"
        ></table-table>

        <employer-notes ref="employerNotes" type="note" />
    </div>
</template>

<script>
import TableFilters from "./filters/table-filters";
import TableEmployerTags from "./tags/table-employer-tags";
import TableCsvDownload from "./csvDownload/table-csv-download";
import TableMultiAccountCbr from "../../EstimatesUi/vue/multi-account-cbr";
import TableSingleAccountCbr from "../../EstimatesUi/vue/single-account-cbr";

export default {
    components: {
        TableMultiAccountCbr,
        TableSingleAccountCbr,
        TableCsvDownload,
        TableEmployerTags,
        TableFilters
    },
    props: [
        'staticData'
    ],
    data() {
        return {
            // user request and selection
            columns: [],
            filters: { month: 'M0'},
            sort_by: null,
            sort_direction: null,
            selected: [],
            search_query: '',

            // computed
            columnDefinition: [],

            // response data
            rows: [],
            sum: {},

            // tech
            loading: true
        };
    },
    methods: {
        select(ids) {
            this.selected = ids;
        },
        filter(filters, callback) {
            this.filters = filters;
            this.refresh().then(callback);
        },
        sort(sort_by, sort_direction) {
            this.sort_by = sort_by;
            this.sort_direction = sort_direction;
            this.refresh();
        },
        search() {
            this.refresh();
        },
        refresh() {
            this.loading = true;
            return axios.post(url(`admin/list-employer/data`), {
                columns: this.columns,
                sort_by: this.sort_by,
                sort_direction: this.sort_direction,
                filters: this.filters,
                search_query: this.search_query
            }).then((response) => {
                this.rows = response.data.rows;
                this.sum = response.data.sum;
                // apply selected columns
                this.rows.forEach((r) => r.checked = this.selected.includes(r.id));
                this.loading = false;
            });
        },
        setView(columns, filters, sort_by, sort_direction) {
            this.loading = true;

            this.filters = filters;

            // columns
            let selectedColumns = _.map(columns, (col_id) => this.staticData.available_columns[col_id]);
            this.columnDefinition = _.values(_.pickBy(selectedColumns, _.identity)); // remove nulls

            return axios.post(url(`admin/list-employer/data`), {
                columns: columns,
                sort_by: sort_by,
                sort_direction: sort_direction,
                filters: filters
            }).then((response) => {
                this.rows = response.data.rows;
                this.sum = response.data.sum;

                this.columns = columns;
                this.sort_by = sort_by;
                this.sort_direction = sort_direction;
                this.selected = [];

                this.$refs.dataTable.select_all = false;

                this.loading = false;
            });
        },
        openEmployerNotes(employerId) {
            this.$refs.employerNotes.showModalFor(employerId);
        }
    },
    mounted() {
        let self = this;
        $("#employer-note-modal").on('hide.bs.modal', function (e) {
            self.refresh();
        });
    }
}
</script>
